// extracted by mini-css-extract-plugin
module.exports = {"name":"welcome-module--name--3rjws","textbox":"welcome-module--textbox--2X3UD"};